export enum RosterType {
  Private = 0,
  Global = 1,
  Shared = 2
}
